import { useKindeAuth } from '@kinde-oss/kinde-auth-react';

export function useKindeUser() {
  const { user } = useKindeAuth();
  return user;
}

export function useUserId() {
  const { user } = useKindeAuth();
  return user?.id || '';
}
